import { useEffect, useState } from 'react';
import { SESSION_EXPIRED_EVENT, isEmbedded } from '~/lib/auth';
import { useT } from '~/i18n';

/**
 * Last resort when a request comes back 401 and the session can't be renewed by
 * any means. Without this the failure surfaces as an error on whatever the user
 * was doing ("Error al preparar el pedido"), which sends people rechecking
 * their data instead of their session.
 *
 * Reloading is the actual fix in both contexts: standalone it bounces through
 * the login guard, embedded it remounts the frame with a token the host just
 * refreshed.
 */
export default function SessionExpiredNotice() {
  const [expired, setExpired] = useState(false);
  const t = useT('common');

  useEffect(() => {
    const onExpired = () => setExpired(true);
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
  }, []);

  if (!expired) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(20, 23, 63, 0.45)', backdropFilter: 'blur(3px)' }}
    >
      <div className="card max-w-sm w-full">
        <div className="card-body text-center gap-3">
        <div className="text-lg font-semibold">{t.sessionExpired.title}</div>
        <p className="text-sm hush">{t.sessionExpired.body}</p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-primary btn-sm w-full"
        >
          {t.sessionExpired.reload}
        </button>
        {!isEmbedded() && (
          <p className="text-xs hush">{t.sessionExpired.hint}</p>
        )}
        </div>
      </div>
    </div>
  );
}
